import { ChangeDetectorRef, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { InputTextarea as InputTextareaBase } from 'prime-ng-old/inputtextarea';
import { BasicInput } from '../basic-input/basic-input';
import * as i0 from "@angular/core";
import * as i1 from "../input-ref/input-ref.directive";
import * as i2 from "../input-ref/form-control-name";
import * as i3 from "@angular/forms";
export const INPUT_TEXT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputTextareaComponent),
  multi: true
};
export let InputTextarea = /*#__PURE__*/(() => {
  class InputTextarea extends InputTextareaBase {
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵInputTextarea_BaseFactory;
        return function InputTextarea_Factory(__ngFactoryType__) {
          return (ɵInputTextarea_BaseFactory || (ɵInputTextarea_BaseFactory = i0.ɵɵgetInheritedFactory(InputTextarea)))(__ngFactoryType__ || InputTextarea);
        };
      })();
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: InputTextarea,
        selectors: [["", "uiInputTextarea", ""]],
        hostVars: 10,
        hostBindings: function InputTextarea_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("p-input-text", true)("p-input-textarea", true)("p-inputtextarea-resizable", ctx.autoResize)("p-component", true)("p-filled", ctx.filled);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return InputTextarea;
})();
// custom component using primeNG styles
export let UiInputTextareaComponent = /*#__PURE__*/(() => {
  class UiInputTextareaComponent extends BasicInput {
    set _autoResize(val) {
      this.autoResize = val;
      if (val) this.rows = 1;
      this.cd.markForCheck();
    }
    constructor(cd) {
      super(cd);
      this.cd = cd;
      this.rows = 4;
    }
    static {
      this.ɵfac = function UiInputTextareaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputTextareaComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputTextareaComponent,
        selectors: [["ui-input-textarea"]],
        inputs: {
          rows: "rows",
          _autoResize: [0, "autoResize", "_autoResize"]
        },
        features: [i0.ɵɵProvidersFeature([INPUT_TEXT_VALUE_ACCESSOR]), i0.ɵɵHostDirectivesFeature([i1.InputRefDirective, {
          directive: i2.FormControlNameStandalone,
          inputs: ["formControlName", "formControlNameStandalone"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 6,
        consts: [["ele", ""], ["uiInputTextarea", "", 3, "focus", "blur", "input", "ngModelChange", "disabled", "readonly", "value", "rows", "autoResize", "ngModel"]],
        template: function UiInputTextareaComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "textarea", 1, 0);
            i0.ɵɵlistener("focus", function UiInputTextareaComponent_Template_textarea_focus_0_listener($event) {
              return ctx.focusInput($event);
            })("blur", function UiInputTextareaComponent_Template_textarea_blur_0_listener($event) {
              return ctx.blurInput($event);
            })("input", function UiInputTextareaComponent_Template_textarea_input_0_listener() {
              return ctx.onModelChange(ctx.value);
            })("ngModelChange", function UiInputTextareaComponent_Template_textarea_ngModelChange_0_listener($event) {
              return ctx.value = $event;
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("disabled", ctx.disabled)("readonly", ctx.readonly)("value", ctx.value)("rows", ctx.rows)("autoResize", ctx.autoResize)("ngModel", ctx.value);
          }
        },
        dependencies: [FormsModule, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, ReactiveFormsModule, InputTextarea],
        styles: ["@layer primeng{.p-inputtextarea-resizable[_ngcontent-%COMP%]{overflow:hidden;resize:none}.p-fluid[_ngcontent-%COMP%]   .p-inputtextarea[_ngcontent-%COMP%]{width:100%}}[_nghost-%COMP%]{display:block}textarea[_ngcontent-%COMP%]{width:100%}.p-input-textarea[_ngcontent-%COMP%]{font-size:1em;color:var(--textColor);background:var(--inputBgColor);padding:var(--inputPadding);border:1px solid #a6a6a6;border-radius:var(--inputBorderRadius);border-color:var(--inputBorderColor);vertical-align:middle;font-family:inherit;transition:border-color .3s,background-color .3s;-webkit-appearance:none;appearance:none}.p-input-textarea[readonly][_ngcontent-%COMP%], .p-input-textarea[disabled][_ngcontent-%COMP%]{border-color:var(--inputDisabledBorderColor);background-color:var(--inputDisabledBgColor);color:var(--inputDisabledTextColor);cursor:default!important;pointer-events:none}.p-input-textarea[_ngcontent-%COMP%]:enabled:hover:not([readonly]){border-color:var(--inputHoverBorderColor);background-color:var(--inputHoverBgColor)}.p-input-textarea[_ngcontent-%COMP%]:enabled:focus:not([readonly]){border-color:var(--focusColor);outline:0 none;box-shadow:none}body.a11y-emphasize-focus[_ngcontent-%COMP%]   .p-input-textarea[_ngcontent-%COMP%]:enabled:focus:not([readonly]){border-width:3px!important}.p-input-textarea.ng-invalid[_ngcontent-%COMP%]{border-color:var(--inputErrorBorderColor)}.ui-form-theme-invisible[_nghost-%COMP%]   .p-input-textarea[_ngcontent-%COMP%], .ui-form-theme-invisible   [_nghost-%COMP%]   .p-input-textarea[_ngcontent-%COMP%]{background:transparent;border-color:transparent}.ui-form-theme-invisible[_nghost-%COMP%]   .p-input-textarea[_ngcontent-%COMP%]:hover, .ui-form-theme-invisible   [_nghost-%COMP%]   .p-input-textarea[_ngcontent-%COMP%]:hover, .ui-form-theme-invisible[_nghost-%COMP%]   .p-input-textarea.ng-touched.ng-invalid[_ngcontent-%COMP%], .ui-form-theme-invisible   [_nghost-%COMP%]   .p-input-textarea.ng-touched.ng-invalid[_ngcontent-%COMP%]{border:1px solid #a6a6a6;border-color:var(--inputBorderColor)}"],
        changeDetection: 0
      });
    }
  }
  return UiInputTextareaComponent;
})();